import axios from "axios";

const getProximoNumeroSobre = async () => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");

  const userData = {
    nic: formattedNic,
    token: token,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
  };
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Transferencias/GetProximoNumeroSobre`, userData);
  return response.data;
};

const proximoNumeroSobre = {
  getProximoNumeroSobre,
};

export default proximoNumeroSobre;
